// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.en3gmk0 {
  transition: opacity 100ms;
}
.en3gmk1 {
  font-size: var(--_18w76bw3m);
  font-weight: var(--_18w76bw3x);
}
.en3gmk2 {
  font-size: var(--_18w76bw3n);
  font-weight: var(--_18w76bw3v);
}
.en3gmk3 {
  font-size: var(--_18w76bw3n);
  font-weight: var(--_18w76bw3w);
}
.en3gmk4 {
  font-size: var(--_18w76bw3n);
  font-weight: var(--_18w76bw3x);
}
.en3gmk5 {
  font-size: var(--_18w76bw3n);
  font-weight: var(--_18w76bw3z);
}
.en3gmk6 {
  font-size: var(--_18w76bw3o);
  font-weight: var(--_18w76bw3w);
}
.en3gmk7 {
  font-size: var(--_18w76bw3o);
  font-weight: var(--_18w76bw3z);
}
.en3gmk8 {
  font-size: var(--_18w76bw3o);
  font-weight: var(--_18w76bw3x);
}
.en3gmk9 {
  font-size: var(--_18w76bw3o);
  font-weight: var(--_18w76bw3z);
}
.en3gmka {
  font-size: var(--_18w76bw3o);
  font-weight: var(--_18w76bw3z);
}
.en3gmkb {
  font-size: var(--_18w76bw3p);
  font-weight: var(--_18w76bw3x);
}
.en3gmkc {
  font-size: var(--_18w76bw3p);
  font-weight: var(--_18w76bw3z);
}
.en3gmkd {
  font-size: var(--_18w76bw3q);
  font-weight: var(--_18w76bw3w);
}
.en3gmke {
  font-size: var(--_18w76bw3q);
  font-weight: var(--_18w76bw3x);
}
.en3gmkf {
  font-size: var(--_18w76bw3q);
  font-weight: var(--_18w76bw3z);
}
.en3gmkg {
  font-size: var(--_18w76bw3r);
  font-weight: var(--_18w76bw3w);
}
.en3gmkh {
  font-size: var(--_18w76bw3r);
  font-weight: var(--_18w76bw3x);
}
.en3gmki {
  font-size: var(--_18w76bw3s);
  font-weight: var(--_18w76bw3x);
}
.en3gmkj {
  font-size: var(--_18w76bw3s);
  font-weight: var(--_18w76bw3z);
}
.en3gmkk {
  font-size: var(--_18w76bw3t);
  font-weight: var(--_18w76bw3w);
  line-height: var(--_18w76bw42);
}
.en3gmkl {
  font-size: var(--_18w76bw3t);
  font-weight: var(--_18w76bw3x);
  line-height: var(--_18w76bw42);
}
.en3gmkm {
  font-size: 48px;
  font-weight: var(--_18w76bw40);
}
.en3gmkn {
  font-size: 32px;
  font-weight: var(--_18w76bw3z);
}
.en3gmko {
  font-size: 28px;
  font-weight: var(--_18w76bw3z);
}
.en3gmkp {
  font-size: 28px;
  font-weight: var(--_18w76bw3x);
}
.en3gmkq {
  font-size: var(--_18w76bw3o);
  color: var(--_18w76bw2e);
}
.en3gmkq:hover, .en3gmkq:focus {
  cursor: pointer;
  color: var(--_18w76bw2d);
  text-decoration: underline;
}
.en3gmks {
  transition: color 200ms, opacity 200ms;
}
.en3gmks:hover {
  opacity: 0.65;
}
@media screen and (max-width: 767px) {
  .en3gmka {
    font-size: var(--_18w76bw3n);
  }
  .en3gmkd {
    font-size: var(--_18w76bw3p);
    font-weight: var(--_18w76bw3x);
  }
  .en3gmkj {
    font-size: var(--_18w76bw3r);
    font-weight: var(--_18w76bw3z);
  }
  .en3gmkk {
    font-size: var(--_18w76bw3r);
    font-weight: var(--_18w76bw3x);
  }
  .en3gmkl {
    font-size: var(--_18w76bw3r);
    font-weight: var(--_18w76bw3x);
  }
  .en3gmkm {
    font-size: 30px;
  }
  .en3gmkn {
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".en3gmk0 {\n  transition: opacity 100ms;\n}\n.en3gmk1 {\n  font-size: var(--_18w76bw3m);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmk2 {\n  font-size: var(--_18w76bw3n);\n  font-weight: var(--_18w76bw3v);\n}\n.en3gmk3 {\n  font-size: var(--_18w76bw3n);\n  font-weight: var(--_18w76bw3w);\n}\n.en3gmk4 {\n  font-size: var(--_18w76bw3n);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmk5 {\n  font-size: var(--_18w76bw3n);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmk6 {\n  font-size: var(--_18w76bw3o);\n  font-weight: var(--_18w76bw3w);\n}\n.en3gmk7 {\n  font-size: var(--_18w76bw3o);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmk8 {\n  font-size: var(--_18w76bw3o);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmk9 {\n  font-size: var(--_18w76bw3o);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmka {\n  font-size: var(--_18w76bw3o);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmkb {\n  font-size: var(--_18w76bw3p);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmkc {\n  font-size: var(--_18w76bw3p);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmkd {\n  font-size: var(--_18w76bw3q);\n  font-weight: var(--_18w76bw3w);\n}\n.en3gmke {\n  font-size: var(--_18w76bw3q);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmkf {\n  font-size: var(--_18w76bw3q);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmkg {\n  font-size: var(--_18w76bw3r);\n  font-weight: var(--_18w76bw3w);\n}\n.en3gmkh {\n  font-size: var(--_18w76bw3r);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmki {\n  font-size: var(--_18w76bw3s);\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmkj {\n  font-size: var(--_18w76bw3s);\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmkk {\n  font-size: var(--_18w76bw3t);\n  font-weight: var(--_18w76bw3w);\n  line-height: var(--_18w76bw42);\n}\n.en3gmkl {\n  font-size: var(--_18w76bw3t);\n  font-weight: var(--_18w76bw3x);\n  line-height: var(--_18w76bw42);\n}\n.en3gmkm {\n  font-size: 48px;\n  font-weight: var(--_18w76bw40);\n}\n.en3gmkn {\n  font-size: 32px;\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmko {\n  font-size: 28px;\n  font-weight: var(--_18w76bw3z);\n}\n.en3gmkp {\n  font-size: 28px;\n  font-weight: var(--_18w76bw3x);\n}\n.en3gmkq {\n  font-size: var(--_18w76bw3o);\n  color: var(--_18w76bw2e);\n}\n.en3gmkq:hover, .en3gmkq:focus {\n  cursor: pointer;\n  color: var(--_18w76bw2d);\n  text-decoration: underline;\n}\n.en3gmks {\n  transition: color 200ms, opacity 200ms;\n}\n.en3gmks:hover {\n  opacity: 0.65;\n}\n@media screen and (max-width: 767px) {\n  .en3gmka {\n    font-size: var(--_18w76bw3n);\n  }\n  .en3gmkd {\n    font-size: var(--_18w76bw3p);\n    font-weight: var(--_18w76bw3x);\n  }\n  .en3gmkj {\n    font-size: var(--_18w76bw3r);\n    font-weight: var(--_18w76bw3z);\n  }\n  .en3gmkk {\n    font-size: var(--_18w76bw3r);\n    font-weight: var(--_18w76bw3x);\n  }\n  .en3gmkl {\n    font-size: var(--_18w76bw3r);\n    font-weight: var(--_18w76bw3x);\n  }\n  .en3gmkm {\n    font-size: 30px;\n  }\n  .en3gmkn {\n    font-size: 26px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
